import { CommonBaseData } from "../shared/data/common-base-data";
import { N201A04OutData } from '../shared/webapi-data/n201a04-out-data';

export class N2013OutputData extends CommonBaseData  {
  // ＡＰＩ転送仕様
  public apiOutData: N201A04OutData;
}



// WEBPACK FOOTER //
// ./src/app/modules/n201/n2013-output-data.ts